import React, { useState } from 'react';
import { TYPES } from '../data/types';
import Coin from '../components/Coin';
import './Results.css';

const TABS = ['Profile','Strengths','Challenges','Famous'];

export default function Results({ result, onRetake }) {
  const [tab, setTab] = useState(0);
  const mbti   = result ? result.split('-')[0] : 'INFP';
  const atCode = result ? (result.split('-')[1] || 'A') : 'A';
  const td     = TYPES[mbti] || TYPES['INFP'];
  const coin   = td.coin;

  const dims = [
    { left:'Extraversion', right:'Introversion', val: mbti[0]==='E'?72:28, letter: mbti[0] },
    { left:'Sensing',      right:'Intuition',    val: mbti[1]==='S'?65:35, letter: mbti[1] },
    { left:'Thinking',     right:'Feeling',      val: mbti[2]==='T'?70:30, letter: mbti[2] },
    { left:'Judging',      right:'Perceiving',   val: mbti[3]==='J'?68:32, letter: mbti[3] },
    { left:'Assertive',    right:'Turbulent',    val: atCode==='A'?71:29,  letter: atCode   },
  ];

  const share = () => {
    if (navigator.share) {
      navigator.share({
        title: `I'm ${td.name} (${mbti}) — ${coin.metal} Coin`,
        text: `Discover your personality coin at prismself.com`,
        url: 'https://prismself.com',
      });
    } else {
      navigator.clipboard?.writeText(`https://prismself.com`);
      alert('Link copied!');
    }
  };

  return (
    <div className="res">
      <div className="r-nav">
        <div className="r-logo">♦ prismself<span>.com</span></div>
      </div>

      {/* Hero */}
      <div className="r-hero">
        <div className="r-hero-inner">
          <div className="r-hero-coin">
            <Coin type={mbti} coin={coin} size={160} />
          </div>
          <div className="r-label">Your Personality Coin</div>
          <div className="r-type">{mbti}</div>
          <div className="r-name">{td.name}</div>
          <div className="r-tagline">{td.tagline}</div>
          <div className="r-badges">
            <span className="r-badge">
              {coin.metal}
            </span>
            <span className="r-badge">
              {coin.rarity}
            </span>
            <span className="r-badge">
              {td.pct} of people
            </span>
          </div>
          <div className="r-hook">{td.hook}</div>
        </div>
      </div>

      {/* AT badge */}
      <div className="r-at">
        <span className="r-at-code">{mbti}-{atCode}</span>
        <span className="r-at-label">
          {atCode === 'A'
            ? '· Assertive — Confident & Stable'
            : '· Turbulent — Ambitious & Self-Critical'}
        </span>
      </div>

      {/* Tabs */}
      <div className="r-content">
        <div className="r-tabs">
          {TABS.map((t, i) => (
            <button key={i} className={`r-tab ${tab === i ? 'on' : ''}`} onClick={() => setTab(i)}>{t}</button>
          ))}
        </div>

        <div className="r-panel fade-in" key={tab}>
          {tab === 0 && (
            <>
              <p className="r-desc">{td.desc}</p>
              <h3 className="r-sub">Personality Dimensions</h3>
              {dims.map((d, i) => (
                <div key={i} className="r-dim">
                  <div className="r-dim-row">
                    <span className={d.val >= 50 ? 'active' : ''}>{d.left}</span>
                    <span className="r-dim-pct">{d.val}%</span>
                    <span className={d.val < 50 ? 'active' : ''}>{d.right}</span>
                  </div>
                  <div className="r-dim-bar">
                    <div className="r-dim-fill" style={{ width:`${d.val}%` }} />
                  </div>
                </div>
              ))}
            </>
          )}
          {tab === 1 && (
            <>
              <h3 className="r-sub">Your Natural Strengths</h3>
              <div className="r-list">
                {td.strengths.map((s, i) => (
                  <div key={i} className="r-item r-item-gold">
                    <span className="r-item-icon">✦</span>
                    <span>{s}</span>
                  </div>
                ))}
              </div>
            </>
          )}
          {tab === 2 && (
            <>
              <h3 className="r-sub">Areas to Grow</h3>
              <div className="r-list">
                {td.challenges.map((c, i) => (
                  <div key={i} className="r-item r-item-red">
                    <span className="r-item-icon">◈</span>
                    <span>{c}</span>
                  </div>
                ))}
              </div>
            </>
          )}
          {tab === 3 && (
            <>
              <h3 className="r-sub">Famous {mbti} — {td.name}</h3>
              <p className="r-famous">{td.famous}</p>
            </>
          )}
        </div>

        {/* Actions */}
        <div className="r-actions">
          <button className="r-share-btn" onClick={share}>
            🪙 Share My Coin
          </button>
          <button className="r-retry" onClick={onRetake}>
            Retake the test
          </button>
        </div>
      </div>
    </div>
  );
}
